module.exports = __webpack_public_path__ + "img/icon_unlocked.e155ebfa.png";